__turbopack_context__.v({
  "fade-in": "Header-module-scss-module__Hi38ua__fade-in",
  "filterButton": "Header-module-scss-module__Hi38ua__filterButton",
  "isOpen": "Header-module-scss-module__Hi38ua__isOpen",
  "root": "Header-module-scss-module__Hi38ua__root",
  "searchContainer": "Header-module-scss-module__Hi38ua__searchContainer",
  "title": "Header-module-scss-module__Hi38ua__title",
});
